import { FC } from "react";
import { Link } from "react-router";

interface WidgetTitleProps {
    linkTitle?: string;
    linkUrl?: string;
    title: string;
    size?: 'base' | 'small';
}

export const WidgetTitle: FC<WidgetTitleProps> = ({
    title,
    linkUrl,
    linkTitle = 'Все',
    size = 'base'
}) => {
    let titleClass = "text-xl w-full uppercase italic text-left text-sky-950 font-bold";
    if (size === 'small') {

    } else {
        titleClass += ' sm:text-2xl lg:text-3xl xl:text-4xl'; 
    }

    return (
        <div className="flex flex-row justify-between items-center pb-3 sm:pb-4">
            <div className={titleClass}>{title}</div>
            {linkUrl && <Link to={linkUrl} className="transition-all bg-slate-200 px-3 py-1 sm:px-4 sm:py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm">{linkTitle}</Link>}
        </div>
    )
}